import { useEffect, useState } from 'react';

/**
 * Creates an object URL for a blob and revokes it when the blob changes or the
 * component unmounts, preventing memory leaks.
 */
export default function useObjectUrl(blob?: Blob) {
  const [objectUrl, setObjectUrl] = useState<string>();

  useEffect(() => {
    if (!blob) {
      setObjectUrl(undefined);
      return;
    }

    const url = URL.createObjectURL(blob);
    setObjectUrl(url);

    return () => URL.revokeObjectURL(url);
  }, [blob]);

  return objectUrl;
}
